<nz-divider></nz-divider>
<form nz-form [formGroup]="amendLeaseFG" >
  <div nz-row>

  <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
    <nz-form-item class="pr-lg">
      <nz-form-label nzRequired> Charge Type
        <i nz-icon nzType="question-circle" nz-tooltip nzTheme="outline" nzTitle="'Damaged Facility'"
          class="tooltip"></i>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'sez.label.validation.required' | translate">
        <nz-select required (ngModelChange)="getChargeDetails($event)" id="damagedFacility" formControlName="damagedFacility" nzAllowClear
          nzShowSearch nzPlaceHolder="Select Damaged Facility">
          <nz-option *ngFor="let obj of dropdownData[0]" nzLabel="{{obj.label}}" nzValue="{{obj.value}}">
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" *ngIf="chargeType!==''">
    <nz-form-item class="pl-lg">
      <nz-form-label> Charge
        <i nz-icon nzType="question-circle" nz-tooltip nzTheme="outline" nzTitle="'Charge'"
          class="tooltip"></i>
      </nz-form-label>
      <nz-form-control nzHasFeedback>
        <input class="fw-bold" [disabled]="true" nz-input id="charges" formControlName="charges">
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="pr-lg">
      <nz-form-label nzRequired>Actions</nz-form-label>
      <nz-form-control [nzErrorTip]="'sez.label.validation.required' | translate" nzValidateStatus="validating">
        <nz-select required id="selectedAction" formControlName="selectedAction">
          <nz-option *ngFor="let action of actions" [nzValue]="action.code" [nzLabel]="action.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item [ngClass]="chargeType==='' ? 'pr-lg' : 'pl-lg'">
      <nz-form-label>Comments</nz-form-label>
      <nz-form-control nzValidateStatus="validating">
        <textarea rows="2" id="comments" formControlName="comments" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()" [disabled]="!amendLeaseFG.valid">Submit</button>
    </div>
  </div>
</div>
</form>
